import React from "react"

/** Flex wrapper that lays out `Resizable` panels and their siblings. */
export default function ResizableContainer({
  children,
  direction = "row",
  style,
}) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: direction === "column" ? "column" : "row",
        ...style,
      }}
    >
      {children}
    </div>
  )
}
